module.exports = __webpack_public_path__ + "img/Operational-risk.a4ec7f7c.png";